import {
  IonApp,
  IonBadge,
  IonRouterOutlet,
  IonSplitPane,
  setupIonicReact,
} from "@ionic/react";
import {
  IonButtons,
  IonContent,
  IonHeader,
  IonMenuButton,
  IonPage,
  IonTitle,
  IonToolbar,
  IonTabBar,
  IonTabButton,
  IonIcon,
  IonLabel, 
  IonItem,
  IonList,
  IonToggle,
} from "@ionic/react";

import { IonReactRouter } from "@ionic/react-router";
import { Redirect, Route, useParams, Switch } from "react-router-dom";
import Menu from "./components/Menu";
import LoginPage from "./pages/Login";
import { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import jwt_decode from "jwt-decode";
import { ar_loginUser, ar_logoutUser } from "./Redux/Actions/AuthActions";

/* Core CSS required for Ionic components to work properly */
import "@ionic/react/css/core.css";

/* Basic CSS for apps built with Ionic */
import "@ionic/react/css/normalize.css";
import "@ionic/react/css/structure.css";
import "@ionic/react/css/typography.css";

/* Optional CSS utils that can be commented out */
import "@ionic/react/css/padding.css";
import "@ionic/react/css/float-elements.css";
import "@ionic/react/css/text-alignment.css";
import "@ionic/react/css/text-transformation.css";
import "@ionic/react/css/flex-utils.css";
import "@ionic/react/css/display.css";

/* Theme variables */
import "./theme/variables.css";
import "./theme/floating-tab-bar.css";
import { home, settings, moon } from "ionicons/icons";
import SUData from "./pages/SUData";
import ETHData from "./pages/ETHData";
import ETHStoreSummary from "./pages/ETHStoreSummary";
import Homepage from "./pages/Homepage";
import SUPred from "./pages/SUPred";
import StoreSummary from "./pages/StoreSummary";
import SuRoutes from "./features/su/routes/SuRoutes";

setupIonicReact();

const NEW_UI_ENABLED = process.env.REACT_APP_NEW_UI === "true";

const normalizeOrg = (org) => {
  const value = (org || "ALL").toString().trim().toUpperCase();
  if (value === "SU" || value === "ETH" || value === "ALL") {
    return value;
  }
  return "ALL";
};

const getDefaultSalesPath = (org) => {
  return normalizeOrg(org) === "ETH" ? "/sales/eth" : "/sales/styleunion";
};

const App = () => {
  const [loading, setLoading] = useState(true);
  const authReducer = useSelector((state) => state.authReducer);
  const dispatch = useDispatch();
  const userOrg = normalizeOrg(authReducer?.user?.org);
  const canAccessSU = userOrg === "SU" || userOrg === "ALL";
  const canAccessETH = userOrg === "ETH" || userOrg === "ALL";
  const hasNewUi = canAccessSU || canAccessETH;
  const showOrgTabs = canAccessSU && canAccessETH;
  const defaultSalesPath = getDefaultSalesPath(userOrg);

  const validateToken = () => {
    setLoading(true);
    try {
      if (localStorage.USERLoginTOKEN) {
        const token = localStorage.getItem("USERLoginTOKEN");
        const decoded = jwt_decode(token);
        const org = normalizeOrg(decoded.org);

        const data = {
          isAuthenticated: true,
          user: {
            userId: decoded.user_id,
            username: decoded.username,
            last_login: decoded.last_login,
            email: decoded.email,
            org,
            region_code: decoded.region_code,
          },
        };

        console.log("data", data, decoded);

        localStorage.setItem("userId", data.user.userId);
        localStorage.setItem("last_login", data.user.last_login);
        localStorage.setItem("org", org);

        dispatch(ar_loginUser(data));
      }
    } catch (error) {
      console.error("Token validation error", error);
    }
    setLoading(false);
  };

  useEffect(() => {
    validateToken();
  }, []);

  const toggleDarkModeHandler = () => document.body.classList.toggle("dark");

  const legacyShell = (
          <IonSplitPane contentId="main">
            <Menu />
            <IonRouterOutlet id="main">
              <IonPage>
                <IonHeader>
                  <IonToolbar>
                    <IonButtons slot="start">
                      <IonMenuButton />
                    </IonButtons>
                    <IonTitle className="no-inline-padding" style={{ paddingInline: 0, paddingLeft: 0, paddingRight: 0 }}>
                      <div
                        id="navbar-portal-div"
                        style={{
                          display: "flex",
                          justifyContent: "space-between",
                          width: "100%",
                          alignItems: "center",
                        }}
                      >
                        {/* <IonBadge color="success">BETA</IonBadge> */}
                      </div>
                    </IonTitle>
                  </IonToolbar>
                </IonHeader>

                <Switch>
                  {/* New UI: old SU / ETH entry points go to /app/home */}
                  {NEW_UI_ENABLED && hasNewUi && (
                    <Redirect exact from="/" to="/app/home" />
                  )}
                  {NEW_UI_ENABLED && canAccessSU && (
                    <Redirect exact from="/sales/styleunion" to="/app/home" />
                  )}
                  {NEW_UI_ENABLED && canAccessSU && (
                    <Redirect from="/sales/styleunion/region/:regionName" to="/app/home" />
                  )}
                  {NEW_UI_ENABLED && canAccessETH && (
                    <Redirect exact from="/sales/eth" to="/app/home" />
                  )}
                  {NEW_UI_ENABLED && canAccessETH && (
                    <Redirect from="/sales/eth/region/:regionName" to="/app/home" />
                  )}
                  {/* Legacy SU view, still reachable from the More page */}
                  {NEW_UI_ENABLED && canAccessSU && (
                    <Route path="/legacy/sales/styleunion/region/:regionName" exact={true}>
                      <IonContent fullscreen>
                        <StoreSummary />
                      </IonContent>
                    </Route>
                  )}
                  {NEW_UI_ENABLED && canAccessSU && (
                    <Route path="/legacy/sales/styleunion" exact={true}>
                      <IonContent fullscreen>
                        <SUData />
                      </IonContent>
                    </Route>
                  )}

                  {/* Legacy ETH view, still reachable from the More page */}
                  {NEW_UI_ENABLED && canAccessETH && (
                    <Route path="/legacy/sales/eth/region/:regionName" exact={true}>
                      <IonContent fullscreen>
                        <ETHStoreSummary />
                      </IonContent>
                    </Route>
                  )}
                  {NEW_UI_ENABLED && canAccessETH && (
                    <Route path="/legacy/sales/eth" exact={true}>
                      <IonContent fullscreen>
                        <ETHData />
                      </IonContent>
                    </Route>
                  )}

                  {/* Style Union region drill-down */}
                  <Route path="/sales/styleunion/region/:regionName" exact={true}>
                    {canAccessSU ? (
                      <IonContent fullscreen>
                        <StoreSummary />
                      </IonContent>
                    ) : (
                      <Redirect to={defaultSalesPath} />
                    )}
                  </Route>

                  {/* Ethnicity region drill-down */}
                  <Route path="/sales/eth/region/:regionName" exact={true}>
                    {canAccessETH ? (
                      <IonContent fullscreen>
                        <ETHStoreSummary />
                      </IonContent>
                    ) : (
                      <Redirect to={defaultSalesPath} />
                    )}
                  </Route>

                  <Route path="/sales/:store" exact={true}>
                    <IonContent fullscreen>
                      {canAccessSU && (
                        <Route path="/sales/styleunion" exact={true}>
                          <SUData />
                        </Route>
                      )}
                      {canAccessETH && (
                        <Route path="/sales/eth" exact={true}>
                          <ETHData />
                        </Route>
                      )}
                      {/* Redirect if user hits a brand they cannot access */}
                      {!canAccessSU && (
                        <Route path="/sales/styleunion" exact={true}>
                          <Redirect to={defaultSalesPath} />
                        </Route>
                      )}
                      {!canAccessETH && (
                        <Route path="/sales/eth" exact={true}>
                          <Redirect to={defaultSalesPath} />
                        </Route>
                      )}
                    </IonContent>
                    {showOrgTabs && !NEW_UI_ENABLED && (
                      <IonTabBar slot="bottom" className="legacy-tabs">
                        <IonTabButton tab="SU" href="/sales/styleunion">
                          <img src="SU.png" alt="subt" />
                        </IonTabButton>
                        <IonTabButton tab="ETH" href="/sales/eth">
                          <IonLabel>
                            <img src="Eth.png" alt="ethbt" />
                          </IonLabel>
                        </IonTabButton>
                      </IonTabBar>
                    )}
                  </Route>

                  {/* SU Sales Prediction */}
                  <Route path="/su-pred" exact={true}>
                    {canAccessSU ? (
                      <IonContent fullscreen>
                        <SUPred />
                      </IonContent>
                    ) : (
                      <Redirect to={defaultSalesPath} />
                    )}
                  </Route>

                  {/* Default route based on user org */}
                  <Route path="*">
                    <Redirect to={NEW_UI_ENABLED && hasNewUi ? "/app/home" : defaultSalesPath} />
                  </Route>
                </Switch>
              </IonPage>
            </IonRouterOutlet>
          </IonSplitPane>
  );

  return loading ? (
    <p>LoginPage</p>
  ) : (
    <IonApp>
      <IonReactRouter>
        {authReducer.isAuthenticated ? (
          NEW_UI_ENABLED && hasNewUi ? (
            <Switch>
              <Route path="/app">
                <SuRoutes />
              </Route>
              <Route>{legacyShell}</Route>
            </Switch>
          ) : (
            legacyShell
          )
        ) : (
          <IonRouterOutlet id="main">
            <Route path="*">
              <LoginPage />
            </Route>
          </IonRouterOutlet>
        )}
      </IonReactRouter>
    </IonApp>
  );
};

export default App;
